import { Component, OnInit, Input, ViewChild, OnDestroy, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { ActionGroupEvent } from 'src/app/types/actiongroupevent';
import { LayerSelectComponent } from 'src/app/components/layer-select/layer-select.component';
import { ActionGroupComponent } from 'src/app/components/action-group/action-group.component';
import { SLLayer } from 'src/app/model/sl-layer';
import { Column, AngularGridInstance, SlickGrid, Formatters } from 'angular-slickgrid';
import { DrawPaneComponent } from 'src/app/components/draw-pane/draw-pane.component';
import { IFeature, Feature } from 'src/app/model/drawing/Feature';
import { ActionsFormatter } from 'src/app/model/formatters/actions-formatter';
import { Decorable, Dict } from 'src/app/types/decorable';
import { EditorAction } from 'src/app/model/map-actions/editor-action';
import { StatefulCSS } from 'src/app/model/stateful_css';
import { PolyFeature } from 'src/app/model/drawing/PolyFeature';
import { LineFeature } from 'src/app/model/drawing/LineFeature';
import { PointFeature } from 'src/app/model/drawing/PointFeature';

@Component({
  selector: 'app-digitizer',
  templateUrl: './digitizer.component.html',
  styleUrls: ['./digitizer.component.scss']
})
export class DigitizerComponent implements OnInit, OnDestroy {

  public hasGeometry = false;
  public geomReady = false;
  private _slMap: ISLMap;
  @Input()
  public set slMap(map: ISLMap) {
    if (this.slMap) {
      return;
    }
    this._slMap = map;
    this.slMap.digitizer = this;
  }
  public get slMap() {
    return this._slMap;
  }
  public layer: SLLayer;
  public geometry: Array<any> = [];
  public subscriptionsSet = false;
  public layerSelReady = true;
  public drawPane: DrawPaneComponent;
  public drawPaneFeature: Feature;
  public onStateChange = new EventEmitter<boolean>();
  private digGrid: AngularGridInstance;
  private slickGrid: SlickGrid;
  private subscriptions: SubScriptionMgr = new SubScriptionMgr();
  private gpsState: StatefulCSS;
  public feature: any = null;
  public get currentIndex(): number {
    if (!this.drawPaneFeature) {
      return -1;
    }
    const selection = this.drawPaneFeature.GetSelectedId();
    let ctr = -1;
    for (const geom of this.geometry) {
      ctr += 1;
      if (geom.id === selection) {
        return ctr;
      }
    }
  }

  @Input() layerSel: LayerSelectComponent;
  @ViewChild('globalActions', { static: true }) globalActions: ActionGroupComponent;

  public options = {
    datasetIdPropertyName: 'id'
  }
  public columnDefinitions: Array<Decorable> = [];
  @Output()
  columnDefinitionsChange = new EventEmitter<Array<Decorable>>();
  constructor(private cd: ChangeDetectorRef) { }

  SetMap(map: ISLMap) {
    // deprecate
  }
  SetLayer(layer: SLLayer) {
    if (!this.layerSelReady) {
      window.requestAnimationFrame(() => {
        this.SetLayer(layer);
      });
      return;
    }
    if (!this.feature) {
      this.drawPane?.Clear();
    }
    this.layer = layer;
    window.requestAnimationFrame(() => {
      this.layerSel.SetLayer(this.layer);

    });
    if (!this.layer) {
      this.TurnOff();
    } else {
      this.TurnOn();
    }
  }
  SetFeature(feature, map: ISLMap, notify = true) {
    if (this.feature && this.feature.layer && (this.feature.layer.id === feature.layer.id)) {
      if (this.feature && this.feature.gid && (feature.gid === this.feature.gid)) return;
    }
    this.geomReady = false;
    if (!this.layerSelReady) {
      window.requestAnimationFrame(() => {
        this.SetFeature(feature, map, notify);
      });
      return;
    }
    if (!this.slMap) {
      window.requestAnimationFrame(() => {
        this.SetFeature(feature, map, notify);
      });
      return;
    }
    this.feature = feature;

    if (this.layer?.id !== feature.layer.id) {
      this.SetLayer(feature.layer);
    }
    /*if (this.subscriptionsSet === false) {
      this.subscriptions.Subscribe(this.globalActions.actions, (action: ActionGroupEvent) => {
        this.slMap.component.HandleToolAction(action);
      });
      this.subscriptionsSet = true;
    }
    */
    this.cd.detectChanges();
  }


  ngOnInit(): void {
    this.layerSel.readyHandler = () => {
      this.layerSelReady = true;
    }
    this.gpsState = new StatefulCSS();
    this.gpsState.SetPrefix('');
    this.gpsState.AddState('good');
    this.gpsState.AddState('bad');
    this.gpsState.AddState('warn');
    this.gpsState.AddState('scanning');
    this.gpsState.AddState('hidden');

    this.gpsState.SetMachine($('img.gps')[0]);
    this.gpsState.SetState('hidden');
    this.SetupDrawPane();

  }
  SetupDrawPane() {
    if (!this.slMap || !this.slMap.component || !this.slMap.component.drawPane) {
      window.requestAnimationFrame(() => {
        this.SetupDrawPane();
      })
      return;
    }
    this.SetDrawPane(this.slMap.component.drawPane);
  }
  HasDigitizerSelection() {

    return this.HasDigitizerLayer();
    //return this.slMap.src.digitizerHasSelection
  }
  HasDigitizerLayer() {
    if (!this.slMap) {
      return false;
    }
    if (!this.layerSel) {
      return false;
    }
    return !!this.layerSel.digitizerLayer;
  }
  HasNextGeom() {
    if (this.HasDigitizerLayer() === false) return false;
    return this.currentIndex < this.geometry.length - 1;

  }
  HasPrevGeom() {
    if (this.HasDigitizerLayer() === false) return false;

    return this.currentIndex > 0;
  }
  NextGeom() {
    if (!this.drawPaneFeature) { return; }
    if (!this.HasNextGeom()) { return; }
    this.drawPaneFeature.Select(this.geometry[this.currentIndex + 1].id);
  }
  PrevGeom() {
    if (!this.drawPaneFeature) { return; }
    if (!this.HasPrevGeom()) { return; }
    this.drawPaneFeature.Select(this.geometry[this.currentIndex - 1].id);
  }
  IsVertexSelected() {
    if (!this.slMap) {
      return false;
    }
    if (!this.drawPane) {
      return false;
    }
    if (!this.HasDigitizerLayer()) {
      return false;
    }
    if (!this.drawPaneFeature) {
      return false;
    }
    return this.drawPaneFeature.vertexSelected;
  }

  SetDrawPane(drawPane: DrawPaneComponent) {
    if (!this.drawPane) {
      this.drawPane = drawPane;
      this.subscriptions.Subscribe(this.drawPane.geometryChange, () => {
        this.geomReady = false;
        this.cd.detectChanges();
        const drawPaneFeature = this.drawPane.GetSelectedFeature();
        if (!!this.drawPaneFeature && !!drawPaneFeature) {
          if (this.drawPaneFeature.id !== drawPaneFeature.id) {
            this.drawPaneFeature = this.drawPane.GetSelectedFeature();
          }
        } else if (!this.drawPaneFeature) {
          this.drawPaneFeature = this.drawPane.GetSelectedFeature();
        }

        if (!!this.drawPaneFeature) {
          this.geometry = this.drawPaneFeature.GetGeometry();
          this.geomReady = true;
        }

        this.cd.detectChanges();



      });
      this.subscriptions.Subscribe(this.drawPane.selectionChange, (info: Dict) => {
        this.cd.detectChanges();
      });
      this.subscriptions.Subscribe(this.drawPane.hasVerticesChange, () => {
        this.cd.detectChanges();
      });

    }
  }
  SetDrawPaneFeatureReady(feature: Feature) {
    if (!this.drawPane) {
      window.requestAnimationFrame(() => {
        this.SetDrawPaneFeatureReady(feature);
      });
      return;
    }

    this.geomReady = false;
    this.cd.detectChanges();

    this.drawPaneFeature = feature;
    this.geometry = feature.GetGeometry();
    this.geomReady = this.geometry.length > 0;
    this.cd.detectChanges();
  }
  ngOnDestroy() {
    this.subscriptions.CancelSubscriptions();
    if (this.slMap) {
      this.slMap.digitizer = null;
    }
  }
  IsSelectedGeom(id: string) {
    if (!this.drawPaneFeature) {
      return false;
    }
    return this.drawPaneFeature.IsSelected(id);
  }
  CheckClicked(geom: any) {

    if (!this.drawPaneFeature) {
      return;
    }
    this.drawPaneFeature.Select(geom.id);
    this.cd.detectChanges();


  }
  JumpTo(geom: any) {
    EditorAction.JumpToGeometry(this.slMap.component, geom);
    this.CheckClicked(geom);
  }
  GPSGeom(geom) {
    this.drawPaneFeature.Select(geom.id);
    EditorAction.GPSVertexUpdate(this.slMap.component, geom);
    this.cd.detectChanges();
  }
  TrashGeom(geom) {
    this.drawPaneFeature.Select(geom.id);
    EditorAction.DeleteVertex(this.slMap.component, {});
    this.cd.detectChanges();
  }
  GetAccuracyIcon(geom): string {
    if (geom.type !== 'point') {
      return '';
    }
    if (!this.drawPaneFeature) {
      return '';
    }
    if (!!geom.coord.spatial.accuracy) {
      const accuracy = geom.coord.spatial.accuracy;
      let state = '';
      if ([undefined, null].indexOf(accuracy) > -1) {
        return 'gps-scan-icon';
      }
      if (accuracy < 10) {
        state = 'gps-static-good';
      } else if (accuracy <= 25) {
        state = 'gps-static-warn';
      } else if (accuracy > 25) {
        state = 'gps-static-bad';
      }
      return state;
    }
    return 'gps-scan-icon';

  }
  GetCoordTitle(geom, which) {
    switch (which) {
      case 'lat':
        return 'Lattitude ' + geom.coord.spatial.lat + '&deg;';
      case 'lng':
        return 'Longitude ' + geom.coord.spatial.lng + '&deg;';

    }

  }
  GetCoordValue(geom, which) {
    const ddeg = geom.coord.spatial[which];
    const deg = Math.floor(ddeg);
    let remainder = ddeg - deg;
    remainder = remainder * 60;
    const mins = Math.floor(remainder);
    remainder = remainder - mins;
    remainder = remainder * 60;
    const secs = Math.floor(remainder);
    return `${deg}&deg;${mins}"${secs}'`;
    // return geom.coord.spatial[which];
  }
  TurnOff(hide: boolean = true, notify: boolean = true) {
    if (this.drawPane?.isOn !== true) return;
    if (!this.drawPane || !this.layerSel || (this.layerSel.digitizerLayer === '')) { return; }
    this.drawPane.TurnOff(hide);
    if (notify === true) {
      this.onStateChange.emit(false);
    }

  }
  TurnOn(notify: boolean = true) {
    if (this.drawPane?.isOn === true) return;
    if (!this.drawPane || !this.layerSel || (this.layerSel.digitizerLayer === '')) { return; }
    this.drawPane.TurnOn();
    if (notify === true) {
      this.onStateChange.emit(true);
    }
  }

}
